import React from 'react'

export const TestImage: React.FC = () => {
  return (
    <div>
      <h3>Test Image Component</h3>
      <img
        src='https://via.placeholder.com/300x200/0000FF/FFFFFF?text=Test+Image'
        alt='Test Image'
        style={{ width: '300px', height: '200px', border: '1px solid #ccc' }}
      />
      <p>If you can see this image, the basic image functionality is working.</p>
    </div>
  )
}

export default TestImage
